import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from '../../../services/i18nService';
import styles from '../header.scss';
import storeManager from '../../../store/StoreManager';
import sessionActions from '../../../actions/SessionActions';
import sessionReader from '../../../store/readHelpers/SessionReader';

const ChatButtonComponent = ({ isChatOpen, offlineMode }) => {
    const store = storeManager.getStore();
    const ariaLabel = isChatOpen ? t('header.closeChatButtonLabel') : t('header.openChatButtonLabel');

    const toggleSidebar = () => {
        if (!isChatOpen && sessionReader.isAnnotationsSidebarOpen()) {
            store.dispatch(sessionActions.setAnnotationsSidebarOpen(false));
        }
        store.dispatch(sessionActions.setChatSidebarOpen(!isChatOpen));
    };

    return (<button
        className={styles.optionsButton}
        aria-label={ariaLabel}
        onClick={toggleSidebar}
        id="chatButton"
        disabled={offlineMode}
    >
        <span className={styles.icon}>
            <span className="sr-only">{ariaLabel}</span>
            <i className="fa fa-comments-o fa-3" aria-hidden="true" />
        </span>
    </button>);
};

ChatButtonComponent.propTypes = {
    isChatOpen: PropTypes.bool.isRequired,
    offlineMode: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
    const { api } = state;
    return {
        isChatOpen: sessionReader.isChatOpen(),
        offlineMode: !api.isOnline,
    };
};

const ChatButton = connect(mapStateToProps)(ChatButtonComponent);

export default ChatButton;
